// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductBanner_content__DNnuN","side":"ProductBanner_side__6H9yJ"};